import { render, staticRenderFns } from "./num-img-item.vue?vue&type=template&id=3b255a60&scoped=true&"
import script from "./num-img-item.vue?vue&type=script&lang=js&"
export * from "./num-img-item.vue?vue&type=script&lang=js&"
import style0 from "./num-img-item.vue?vue&type=style&index=0&id=3b255a60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b255a60",
  null
  
)

export default component.exports